<template>
    <div class="exercise">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'Exercise'
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";

    .exercise
    {
        
    }
</style>
